import { render } from "./EventRegPayment.vue?vue&type=template&id=b24932b4&scoped=true"
import script from "./EventRegPayment.vue?vue&type=script&lang=js"
export * from "./EventRegPayment.vue?vue&type=script&lang=js"

import "./EventRegPayment.vue?vue&type=style&index=0&id=b24932b4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24932b4"]])

export default __exports__